import { render, staticRenderFns } from "./InformationalFields.vue?vue&type=template&id=940f522c"
import script from "./InformationalFields.vue?vue&type=script&lang=js"
export * from "./InformationalFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports